// taxUtils.ts - نسخة مستقرة نهائية ✅

import { loadLocalDeviceSettings } from './localPrinterSettings';
import api from './api';

export interface TaxSettings {
  tax_rate: number;
  service_rate: number;
  apply_tax_to_pos: boolean;
  apply_service_to_pos: boolean;
  apply_tax_to_tables: boolean;
  apply_service_to_tables: boolean;
}

// ✅ Cache بسيط ومستقر
let cachedSettings: TaxSettings | null = null;
let lastFetch: number = 0;
let isFetching = false;
const CACHE_DURATION = 5 * 60 * 1000; // 5 دقائق

// ✅ Fallback محلي سريع
function getLocalFallback(): TaxSettings {
  try {
    const localSettings = loadLocalDeviceSettings();
    return {
      tax_rate: localSettings.tax?.tax_rate ?? 14,
      service_rate: localSettings.tax?.service_rate ?? 12,
      apply_tax_to_pos: localSettings.tax?.apply_tax_to_pos !== false,
      apply_service_to_pos: localSettings.tax?.apply_service_to_pos !== false,
      apply_tax_to_tables: localSettings.tax?.apply_tax_to_tables !== false,
      apply_service_to_tables: localSettings.tax?.apply_service_to_tables !== false,
    };
  } catch {
    return {
      tax_rate: 14,
      service_rate: 12,
      apply_tax_to_pos: true,
      apply_service_to_pos: true,
      apply_tax_to_tables: true,
      apply_service_to_tables: true,
    };
  }
}

// ✅ الدالة الرئيسية (بسيطة ومستقرة)
export async function getTaxSettings(forceRefresh: boolean = false): Promise<TaxSettings> {
  const now = Date.now();
  
  // استخدام الكاش
  if (!forceRefresh && cachedSettings && (now - lastFetch) < CACHE_DURATION) {
    return cachedSettings;
  }
  
  // منع الطلبات المتكررة
  if (isFetching) {
    return getLocalFallback();
  }
  
  isFetching = true;
  
  try {
    // محاولة جلب من السيرفر
    const response = await api.get('/api/settings');
    
    if (Array.isArray(response.data)) {
      const taxSetting = response.data.find(s => s.key === 'tax_settings');
      if (taxSetting?.value) {
        try {
          const data = JSON.parse(taxSetting.value);
          cachedSettings = {
            tax_rate: data.tax_rate ?? 14,
            service_rate: data.service_rate ?? 12,
            apply_tax_to_pos: data.apply_tax_to_pos !== false,
            apply_service_to_pos: data.apply_service_to_pos !== false,
            apply_tax_to_tables: data.apply_tax_to_tables !== false,
            apply_service_to_tables: data.apply_service_to_tables !== false,
          };
          lastFetch = now;
          return cachedSettings;
        } catch {}
      }
    }
  } catch {
    // تجاهل الخطأ - نستخدم المحلي
  } finally {
    isFetching = false;
  }
  
  return getLocalFallback();
}